export const graphqlBaseUrl = "https://api-dev.travelnet.in/graphql/hotels";
// export const graphqlBaseUrl = process.env.REACT_APP_BACKEND_URL;
